import React, { ReactNode, useRef, useState } from 'react';
import { useModel } from '../context/ModelContext';
import { Globe2, Settings2, Menu, X } from 'lucide-react';
import ToastHost from './shared/ToastHost';

interface MainLayoutProps {
  children: ReactNode;
  onOpenSettings?: () => void;
}

export const MainLayout: React.FC<MainLayoutProps> = ({ children, onOpenSettings }) => {
  const { solvingCount } = useModel();
  const [navigationOpen, setNavigationOpen] = useState(false);
  const edgeButton = useRef<HTMLButtonElement>(null);
  const inNavigation = (target: EventTarget | null) => target instanceof Element && !!target.closest('.app-rail, .research-nav');
  const closeNavigation = () => { setNavigationOpen(false); edgeButton.current?.focus(); };
  return <div className={`app-shell${navigationOpen ? ' navigation-open' : ''}`}
    onClick={event => { if (event.target instanceof Element && event.target.closest('.research-nav a, .app-brand')) closeNavigation(); }}
    onMouseMove={event => { if (event.clientX <= 12) setNavigationOpen(true); else if (event.clientX > 232) setNavigationOpen(false); }}
    onFocusCapture={event => { if (inNavigation(event.target)) setNavigationOpen(true); }}
    onKeyDown={event => { if (event.key === 'Escape' && navigationOpen) { event.preventDefault(); closeNavigation(); } }}>
    <button ref={edgeButton} className="navigation-edge" aria-label="Open navigation" aria-expanded={navigationOpen}
      aria-controls="research-navigation" onMouseEnter={() => setNavigationOpen(true)} onClick={() => setNavigationOpen(true)}><Menu size={18} /></button>
    <header className="app-rail">
      <button className="navigation-close" aria-label="Close navigation" onClick={closeNavigation}><X size={18} /></button>
      <a className="app-brand" href="#/overview" aria-label="Trade Model Analysis overview">
        <Globe2 size={30} strokeWidth={1.25} aria-hidden="true" />
        <span>Trade Model<span>Analysis</span></span>
      </a>
      <div className="rail-footer">
        {solvingCount > 0 && <div className="solving-indicator" role="status">
          <span className="status-dot-solving" />{solvingCount} solving…
        </div>}
        {onOpenSettings && <button className="rail-settings" aria-label="Connection settings" onClick={onOpenSettings}>
          <Settings2 size={16} aria-hidden="true" /><span>Connection settings</span>
        </button>}
      </div>
    </header>
    <main id="workspace-content" onPointerDown={event => { if (!inNavigation(event.target)) setNavigationOpen(false); }}>{children}</main>
    <ToastHost />
  </div>;
};
